module.exports = __webpack_public_path__ + "img/ofisproIcon.9c647173.svg";